import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { TyreSpecsPage } from '@/features/tyre-specs/tyre-specs-page';

/** The node's tyre prices ("Dækoversigt"). Listing requires `pricing:read`; changing `:write`. */
export const Route = createFileRoute('/_app/tyre-specs')({
  staticData: { featureKey: 'tyre-specs' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, { feature: 'tyre-specs', permissions: ['pricing:read'] }),
  component: TyreSpecsPage,
});
